const state = {
  loginModalOpen: false,
  _resolver: null,
  _rejecter: null,
}

const mutations = {
  SET_LOGIN_MODAL_OPEN(state, open) {
    state.loginModalOpen = open
  },
  SET_PROMISE_HANDLERS(state, { resolve, reject }) {
    state._resolver = resolve
    state._rejecter = reject
  },
  CLEAR_PROMISE_HANDLERS(state) {
    state._resolver = null
    state._rejecter = null
  },
}

const actions = {
  openLoginModal({ state, commit }) {
    if (state.loginModalOpen && state._resolver) {
      // Já existe uma promessa em andamento
      return new Promise((resolve, reject) => {
        // Encaminha para o mesmo fluxo ao concluir
        const prevResolve = state._resolver
        const prevReject = state._rejecter
        commit('SET_PROMISE_HANDLERS', {
          resolve: v => { try { prevResolve(v) } catch (e) {} resolve(v) },
          reject: e => { try { prevReject(e) } catch (e2) {} reject(e) },
        })
      })
    }

    commit('SET_LOGIN_MODAL_OPEN', true)
    return new Promise((resolve, reject) => {
      commit('SET_PROMISE_HANDLERS', { resolve, reject })
    })
  },
  resolveLoginModal({ state, commit }) {
    const resolver = state._resolver
    commit('SET_LOGIN_MODAL_OPEN', false)
    commit('CLEAR_PROMISE_HANDLERS')
    if (typeof resolver === 'function') resolver()
  },
  rejectLoginModal({ state, commit }, payload) {
    const rejecter = state._rejecter
    commit('SET_LOGIN_MODAL_OPEN', false)
    commit('CLEAR_PROMISE_HANDLERS')
    if (typeof rejecter === 'function') rejecter(payload || new Error('cancelled'))
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
